<template>
  <div class="main">
    帮助中心
  </div>
</template>

<script>
  export default {
    name:'helpCenter'
  }
</script>

<style scoped lang="scss">
  .main{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// helpCenter.vue?6be955c4